var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3017",
    "data-name": "Group 3017",
    transform: "translate(-335 -167)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_500",
    "data-name": "Rectangle 500",
    width: 8,
    height: 8,
    transform: "translate(335 167)",
    fill: "#272d3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_503",
    "data-name": "Rectangle 503",
    width: 8,
    height: 8,
    transform: "translate(335 183)",
    fill: "#272d3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_501",
    "data-name": "Rectangle 501",
    width: 8,
    height: 8,
    transform: "translate(351 167)",
    fill: "#272d3b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_502",
    "data-name": "Rectangle 502",
    width: 8,
    height: 8,
    transform: "translate(351 183)",
    fill: "#272d3b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuBox);
export default __webpack_public_path__ + "static/media/menu_box.6dcc965635e410ad283c362d642846f2.svg";
export { ForwardRef as ReactComponent };